import { useEffect } from 'react';
import { PRODUCT_NAME } from '../lib/version';

/* "Users · NecroMancer V3" in the tab. Pass nothing for the product name alone. */
/* Pass FALSE to leave the tab title alone - for a page rendered inside an overlay, where the
 * browser tab still belongs to whatever page the user is actually on. */
export default function usePageTitle(title) {
  useEffect(() => {
    if (title === false) return undefined;
    const prev = document.title;
    document.title = title ? `${title} · ${PRODUCT_NAME}` : PRODUCT_NAME;
    return () => { document.title = prev; };
  }, [title]);
}
